import React from "react";
import SpaceGuestBadge from "./SpaceGuestBadge";
import IconButton from "components/common/IconButton";
import AvatarStack from "components/common/AvatarStack";
import { Space, SpaceGuest, SpaceMember } from "redux/Ldb/types/spaceTypes";
import SpaceDetailsSettingsModal from "./SpaceDetailsSettingsModal";
import useToggle from "hooks/useToggle";

type SpaceDetailsHeaderProps = {
    expandConversation: boolean;
    handleToggleExpandConversation: () => void;
    togglePinnedSideBar: () => void;
    toggleMembersSidebar: () => void;
    isGuest: boolean;
    spaceData: Space | null;
    activeTab: number;
};

export default function SpaceDetailsHeader(props: SpaceDetailsHeaderProps) {
    const {
        handleToggleExpandConversation,
        isGuest,
        togglePinnedSideBar,
        toggleMembersSidebar,
        spaceData,
        activeTab,
    } = props;

    const spaceName = spaceData?.name || "Untitled Space";
    const [spaceDetailsSettingsModal, toggleSpaceDetailsSettingsModal] = useToggle();

    return (
        <>
            <div className="pt-[16px] px-[25px] flex items-center justify-between gap-4 relative z-10">
                <div className="flex items-center gap-2 overflow-auto">
                    <button onClick={handleToggleExpandConversation} className="cursor-pointer">
                        <i className="ri-layout-left-line"></i>
                    </button>

                    <div
                        className="flex items-center gap-2 cursor-pointer"
                        onClick={toggleSpaceDetailsSettingsModal}
                    >
                        <p className="text-sm font-rocGroteskMedium font-semibold truncate max-w-[500px] whitespace-nowrap">
                            {spaceName || "Untitled Space"}
                        </p>
                        <i className="ri-arrow-down-s-line text-lg text-slate-400"></i>
                    </div>

                    {isGuest && <SpaceGuestBadge />}
                </div>

                <div className="flex items-center gap-[12px] items-center">
                    {activeTab === 0 && (
                        <IconButton
                            className="bg-slate-100 text-slate-500"
                            color="secondary"
                            onClick={togglePinnedSideBar}
                        >
                            <i className="ri-pushpin-fill text-lg"></i>
                        </IconButton>
                    )}

                    {spaceData?.members?.length > 0 && (
                        <AvatarStack
                            onClick={toggleMembersSidebar}
                            images={spaceData?.members?.map((collaborator) => {
                                const spaceMember = collaborator as unknown as SpaceMember;
                                const spaceGuest = collaborator as unknown as SpaceGuest;
                                return {
                                    src: spaceMember?.ldb?.profile?.avatar,
                                    alt: spaceMember?.ldb?.fullName || spaceGuest?.guest?.firstName,
                                };
                            })}
                            max={2}
                        />
                    )}
                </div>
            </div>

            {spaceDetailsSettingsModal && (
                <SpaceDetailsSettingsModal
                    open={spaceDetailsSettingsModal}
                    closeModal={toggleSpaceDetailsSettingsModal}
                    spaceData={spaceData}
                />
            )}
        </>
    );
}
